import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded"
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material"
import { isWindows } from "react-device-detect"

interface Props {
    label: string
    disabled: boolean
    onClick: () => void
}

const DeleteGraphic = ({ label, disabled, onClick }: Props) => {
    const handleDeleteGraphic = () => {
        onClick()
    }
    return (
        <MenuItem key="clear" onClick={handleDeleteGraphic} disabled={disabled}>
            <ListItemIcon sx={{ color: "error.main" }}>
                <DeleteRoundedIcon />
            </ListItemIcon>
            <ListItemText sx={{ color: "error.main" }}>{label}</ListItemText>
            <Box component="span" sx={{ fontSize: "12px", color: "error.main" }}>
                {isWindows ? "Ctrl Shift Del" : "⇧ ⌘ ⌫"}
            </Box>
        </MenuItem>
    )
}

export default DeleteGraphic
